import { LoadingState } from "./ui";

function PageLoader({ children, style }) {
  return (
    <LoadingState label={children} style={{ minHeight: "200px", ...style }} />
  );
}

export default PageLoader;
